import { Switch as SwitchPrimitive } from "radix-ui";
import type * as React from "react";
import { cn } from "../../lib/utils.ts";

function Switch({
    className,
    ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root>) {
    return (
        <SwitchPrimitive.Root
            data-slot="switch"
            className={cn(
                "peer group/switch relative inline-flex h-7 w-[46px] shrink-0 touch-manipulation items-center rounded-full border border-doberman-black/8 bg-doberman-black/12 p-[3px] outline-none transition-[background-color,transform] duration-200 before:absolute before:-inset-x-1 before:-inset-y-2 before:rounded-full active:scale-[0.96] data-[state=checked]:bg-doberman-black disabled:cursor-not-allowed disabled:opacity-50 motion-reduce:transition-none motion-reduce:active:scale-100 focus-visible:ring-2 focus-visible:ring-labrador-yellow focus-visible:ring-offset-2 focus-visible:ring-offset-maltese-white",
                className,
            )}
            {...props}
        >
            <SwitchPrimitive.Thumb
                data-slot="switch-thumb"
                className="pointer-events-none block size-[22px] rounded-full bg-true-white ring-0 transition-transform duration-200 motion-reduce:transition-none data-[state=checked]:translate-x-[18px] data-[state=unchecked]:translate-x-0"
            />
        </SwitchPrimitive.Root>
    );
}

export { Switch };
